"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[11897,19341],{

/***/ 11897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84292);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19341);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);









var ParallaxWrapper = function(param) {
    var children = param.children, className = param.className, elementRef = param.elementRef, position = param.position, speed = param.speed, isHomepageIntro = param.isHomepageIntro;
    var isMobileResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_5__/* .selectIsMobile */ .eD);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,react_spring__WEBPACK_IMPORTED_MODULE_2__/* .useSpring */ .q_)(function() {
        return {
            offset: 0
        };
    }), 2), offset = ref[0].offset, set = ref[1];
    var calc = function(o) {
        return "translateY(".concat(o * (isHomepageIntro ? speed : 0.09), "px)");
    };
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_4___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, className, className));
    var style = {
        position: position || "absolute",
        transform: offset.to(calc)
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleOnScroll = function() {
            var ref = isHomepageIntro ? elementRef : containerRef, container = ref.current;
            var pageYOffset = window.pageYOffset;
            if (container) {
                var ref1 = container.getBoundingClientRect(), elemYOffset = ref1.top;
                if (isHomepageIntro) {
                    if (!isMobileResolution) {
                        var resultOffset = pageYOffset <= 0 ? 0 : pageYOffset - elemYOffset;
                        set({
                            offset: resultOffset
                        });
                    }
                } else {
                    set({
                        offset: elemYOffset
                    });
                }
            }
        };
        handleOnScroll();
        window.addEventListener("scroll", handleOnScroll);
        return function() {
            return window.removeEventListener("scroll", handleOnScroll);
        };
    }, [
        elementRef,
        isHomepageIntro,
        set,
        isMobileResolution, 
    ]);
    switch(isHomepageIntro){
        case true:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spring__WEBPACK_IMPORTED_MODULE_2__/* .animated.div */ .q.div, {
                ref: children ? null : elementRef,
                className: classNames,
                style: style,
                children: children
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: containerRef,
                className: classNames,
                style: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spring__WEBPACK_IMPORTED_MODULE_2__/* .animated.div */ .q.div, {
                    style: style,
                    children: children
                })
            });
    }
};
ParallaxWrapper.defaultProps = {
    className: null,
    elementRef: null,
    position: "",
    speed: 0,
    isHomepageIntro: false,
    children: null
};
ParallaxWrapper.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    elementRef: prop_types__WEBPACK_IMPORTED_MODULE_8___default().instanceOf(Object),
    position: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    speed: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().number),
    isHomepageIntro: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool)
};
/* harmony default export */ __webpack_exports__["default"] = (ParallaxWrapper);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 84292:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* reexport safe */ _react_spring_web__WEBPACK_IMPORTED_MODULE_0__.q; },
/* harmony export */   "q_": function() { return /* reexport safe */ _react_spring_web__WEBPACK_IMPORTED_MODULE_0__.q_; }
/* harmony export */ });
/* harmony import */ var _react_spring_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14869);
// src/index.ts



/***/ })

}]);